export * from 'utils/utils.js';
import { sortObjectByOrder } from 'utils/utils.js';

// Lists an id-keyed object sorted by `order`, with the key attached and empty entries removed
export function sortObjectToList(items) {
	return sortObjectByOrder(items, (value, id) => value && { ...value, id }).filter(Boolean);
}
